import { createTRPCReact } from '@trpc/react-query';
import { httpBatchLink } from '@trpc/client';
import type { AppRouter } from './appRouter';

export const trpc = createTRPCReact<AppRouter>();

// tRPC client configuration
export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: '/api/trpc',
      // Optional: Add headers for authentication
      headers: () => {
        return {
          // Add auth headers if needed
        };
      },
    }),
  ],
});